/**
 * Ein Beispielsong, damit die App beim ersten Start nicht leer ist.
 * Zeigt beide Schreibweisen ohne jede Sonderzeichen-Regel:
 * Taktraster für die Form, Akkorde über dem Text für gesungene Stellen.
 * Bewusst eigener Text, kein fremdes Liedgut.
 */
import type { Song } from '../types.ts';
import { emptySong } from './repo.ts';

const BODY = `Intro: ebm, Eb Eb, dm7, D,

Vers I: ebm, -, Eb, -, dm7, ~, D, ~,
ebm, -, Eb, -, dm7, D, Ab, Ab,

Instr.: , , , , , , , ,

Prechorus: ebm, Eb,  4x

Chorus: dm7 D, Ab, dm7 D, Ab,  3x

Gesang:
Ebm            Ab
Montag früh im Proberaum,
Ebm               Dm7     Ebm
alles klingt noch halb im Traum.

Schluss:
Intro zweimal, dann Ebm
`;

export function demoSong(projectId: string): Song {
  return emptySong(projectId, {
    title: 'Übe-Song in Ebm',
    artist: 'Beispiel',
    key: 'Ebm',
    tempo: 92,
    timeSignature: '4/4',
    notes: 'Beispielsong zum Ausprobieren. Kann bedenkenlos gelöscht werden.',
    body: BODY,
    scrollSpeed: null,
  });
}
